import { Product, TeamMember } from '../types';

import CebuPortImg from '../assets/images/cpa.png';
import LoggleImg from '../assets/images/loggle.png';
import SqloomImg from '../assets/images/sqloom.png';
import AlexImg from '../assets/images/team-alex.jpg';
import SarahImg from '../assets/images/team-sarah.jpg';
import JamesImg from '../assets/images/team-james.jpg';
import MariaImg from '../assets/images/team-maria.jpg';

export const PRODUCTS: Product[] = [
  {
    id: 'cebu-port',
    name: 'Cebu Port Authority',
    tagline: 'Streamlined Maritime Permits',
    description: 'A comprehensive digital portal for port operations. We digitized the permit application process, enabling hassle-free approvals for cargo handling, transport accreditation, and ancillary services.',
    imageUrl: CebuPortImg,
    tags: ['Government', 'Web Portal', 'Automation'],
    features: ['Online Permit Application', 'Real-time Tracking', 'Secure Payment Gateway'],
    ctaLink: 'https://permits.cpa.gov.ph',
    ctaText: 'Visit Portal',
    themeColor: 'blue',
  },
  {
    id: 'loggle',
    name: 'Loggle',
    tagline: 'Log Intelligence, De-cluttered',
    description: 'A self-hosted log management stack built on open standards. Loggle cuts through the noise, allowing dev teams to surface signals that matter and keep incident response calm.',
    imageUrl: LoggleImg,
    tags: ['DevTools', 'Open Source', 'Observability'],
    features: ['Live Search Highlight', 'OTEL Era Compatible', 'Self-Hosted'],
    ctaLink: 'https://loggle.co',
    ctaText: 'Explore Platform',
    themeColor: 'indigo',
  },
  {
    id: 'sqloom',
    name: 'Sqloom',
    tagline: 'Local AI for SQL',
    description: 'Secure, simple, and VS Code native. Chat with your SQL Server using local LLMs. Script tables, inspect definitions, and diagnose slow queries without your data ever leaving your workstation.',
    imageUrl: SqloomImg,
    tags: ['AI/ML', 'VS Code Extension', 'Database'],
    features: ['Local Runtime', 'Privacy First', 'Copilot Integration'],
    ctaLink: 'https://sqloom.dev',
    ctaText: 'Get Early Access',
    themeColor: 'emerald',
  }
];

export const TEAM: TeamMember[] = [
  {
    id: '1',
    name: 'Alex Rivera',
    role: 'Lead Full Stack Engineer',
    bio: 'Architecting scalable solutions for government and enterprise sectors. Passionate about clean code and React patterns.',
    imageUrl: AlexImg,
    socials: { github: '#', twitter: '#' }
  },
  {
    id: '2',
    name: 'Sarah Chen',
    role: 'Product Designer',
    bio: 'Crafting intuitive interfaces that simplify complex workflows. The creative mind behind the Loggle and Sqloom aesthetics.',
    imageUrl: SarahImg,
    socials: { linkedin: '#' }
  },
  {
    id: '3',
    name: 'James Oconnell',
    role: 'Backend Systems Engineer',
    bio: 'Specialist in high-availability systems and database optimization. Ensures our platforms run smoothly under load.',
    imageUrl: JamesImg,
    socials: { github: '#', linkedin: '#' }
  },
  {
    id: '4',
    name: 'Maria Garcia',
    role: 'AI Research Engineer',
    bio: 'Driving the local AI capabilities of Sqloom. Expert in optimizing LLMs for edge devices and developer workflows.',
    imageUrl: MariaImg,
    socials: { twitter: '#', github: '#' }
  }
];
